import React, { useState } from "react";
import { string, shape, object } from "prop-types";
import get from "lodash/get";
import { useDispatch } from "react-redux";
import { collectionToStories, LazyCollection } from "@quintype/components";

import { getCollectionTemplate } from "../../get-collection-template";
import { getLoadMoreStories } from "../../utils";
import SectionMenu from "./section-menu";
import List from "../../rows/list";
import TagFilter from "../../molecules/tag-filter";
import ScrollToTop from "../../atoms/back-to-top-button";

import "./section-page.m.css";

const SectionPage = (props) => {
  // will be getting initially 9 items, but showing only 8 for loadmore functionality
  const collection = get(props, ["data", "collection"], {});
  const section = get(props, ["data", "section"], "");
  const sections = get(props, ["config", "sections"], {});
  const currentPath = get(props, ["currentPath"], "");
  const lang = get(props, ["data", "lang"], "");

  const dispatch = useDispatch();

  const setLoading = (isloading) => {
    dispatch(isloading ? { type: "QT-PAGE_LOADING" } : { type: "QT-PAGE_FINISHED_LOADING" });
  };

  const stories = collectionToStories(collection);

  const childCollections = get(collection, ["items"], []).filter((collections) => collections.type === "collection");
  const [storiesToRender, setStoriesToRender] = useState(8);
  const [sectionPageStories, setStories] = useState(stories);

  const getMoreStories = async () => {
    setLoading(true);
    const section = get(props, ["data", "section"], null);
    const sectionId = get(section, ["id"], "");
    const sectionCollection = get(section, ["collection"], null);
    const sectionCollectionId = get(sectionCollection, ["id"], "");
    const collectionId = get(collection, ["id"], "");

    const getSlug = () => {
      if (section) {
        if (sectionCollection === null) {
          return sectionId;
        }
        return sectionCollectionId;
      }

      return collectionId;
    };

    const getShouldUseCollection = () => {
      if (section) {
        return !!sectionCollection;
      }

      return !!collection;
    };

    await getLoadMoreStories({
      offset: storiesToRender,
      limit: 8,
      slug: getSlug(),
      query: "section-id",
      setStories: setStories,
      storiesToRender: storiesToRender,
      setStoriesToRender: setStoriesToRender,
      stories: sectionPageStories,
      isSectionPage: true,
      shouldUseCollection: getShouldUseCollection(),
    });

    setLoading(false);
  };

  return (
    <div className="container" styleName="wrapper">
      <SectionMenu collection={collection} sections={sections} section={section} />
      <TagFilter slug={currentPath} lang={lang} pageType="section-page" />
      {childCollections.length > 0 ? (
        <LazyCollection collection={{ items: childCollections }} collectionTemplates={getCollectionTemplate} />
      ) : (
        <List
          stories={sectionPageStories.slice(0, storiesToRender)}
          showLoadmore={sectionPageStories.length > storiesToRender}
          loadMoreStories={getMoreStories}
        />
      )}
      <ScrollToTop />
    </div>
  );
};

SectionPage.propTypes = {
  pageType: string,
  data: shape({
    collection: object,
    section: string,
  }),
  config: object,
  currentPath: string,
};

export { SectionPage };
